import React, { useEffect, useState } from "react";
import { Box, Typography, Container, Stack} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import GradientHeader from "../../components/product/GradientHeader";

const NewsList = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [selectedCategory, setSelectedCategory] = useState('ALL');
  const [selectedDate, setSelectedDate] = useState('ALL');

  
  const categories = [
        { label: 'ALL', value: 'ALL' },
        { label: 'お知らせ', value: 'notice' },
        { label: 'プレスリリース', value: 'press' },
        { label: 'プロダクトアップデート', value: 'update' },
        { label: 'メディア掲載', value: 'media' }
    ];
    const newsItems = [
        {
            date: '2025.06.22',
            category: 'press',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
        {
            date: '2025.05.12',
            category: 'notice',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
        {
            date: '2025.03.18',
            category: 'media',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
        {
            date: '2025.03.18',
            category: 'update',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
        {
            date: '2025.02.01',
            category: 'press',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
        {
            date: '2025.01.06',
            category: 'media',
            title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            link: '/newsdetails'
        },
    ];

  // const filteredNews = selectedCategory === 'ALL'
  // ? newsItems
  // : newsItems.filter((item) => item.category === selectedCategory);

  const uniqueDates = ['ALL', ...Array.from(new Set(newsItems.map(item => item.date)))];

  const filteredNews = newsItems.filter((item) => {
    const categoryMatch = selectedCategory === 'ALL' || item.category === selectedCategory;
    const dateMatch = selectedDate === 'ALL' || item.date === selectedDate;
    return categoryMatch && dateMatch;
  });

  const headtitle = "News";
  const headsubTitle = "ニュース";
  const headsubdec = "ニュース";
  
  return (
    <>
      <Helmet>
        <title>特長 | Global Japan Network</title>
        <meta property="og:title" content="特長 | Global Japan Network" />
        {/* <meta property="og:description" content="グローバルジャパンネットワークは、信頼性の高いITオフショア開発・オフショアシステム開発を提供。高品質・低コストでビジネスを支援します。" /> */}
        <meta property="og:url" content="https://gjnetwork.jp" />
        <meta property="og:image" content="https://gjnetwork.jp/img/global-japan-og-img.jpg" />
        <link rel="canonical" href={`https://gjnetwork.jp${window.location.pathname}`} />
      </Helmet>
      <GradientHeader
        title={headtitle}
        subTitle={headsubTitle}
        subdesc={headsubdec}
      />
      <Container>
        <Stack py={5}>
          <Box style={{marginBottom: '100px'}}>
                  <div style={{marginBottom: '50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div>
                      {categories.map((cat) => (
                        <button
                        key={cat.value}
                        onClick={() => setSelectedCategory(cat.value)}
                        style={{
                          padding: '8px 16px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: 500,
                          fontFamily: "Noto Sans JP, sans-serif",
                          transition: 'background-color 0.2s, color 0.2s',
                          backgroundColor: selectedCategory === cat.value ? '#EA5514' : '#ea55141f',
                          color: selectedCategory === cat.value ? '#ffffff' : '#EA5514',
                          border: 'none',
                          cursor: 'pointer',
                          marginRight: '8px',
                        }}
                        >
                        {cat.label}
                        </button>
                    ))}

                    </div>
               
                    <select
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      style={{
                        padding: '8px 16px',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontWeight: 500,
                        fontFamily: "Noto Sans JP, sans-serif",
                        color: '#000',
                        backgroundColor: '#fff',
                        backgroundImage: `url("data:image/svg+xml;utf8,<svg fill='black' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>")`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'right 10px center',
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        cursor: 'pointer',
                        minWidth: '160px',
                      }}
                    >
                      {uniqueDates.map((date) => (
                        <option key={date} value={date}>
                          {date === 'ALL' ? 'All' : date}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='news-and-article-content-wrapper'>
                      {filteredNews.map((item, index) => (
                          <div key={index} className='news-and-article-item' style={{display: 'flex', alignItems: 'center', gap: '50px', padding: '30px 0', borderWidth: '1px 0', borderStyle :'solid', borderColor: 'rgb(238, 238, 238)'}}>
                              <div style={{width: '10%'}}>
                              <Typography variant='h5' sx={{fontSize: '14px', color: '#000'}}>{item.date}</Typography>
                              </div>
                              <div style={{width: '20%'}}>
                              <Typography variant='h5' sx={{fontSize: '14px', fontWeight: '600', color: '#EA5514', padding: '5px 10px', background: '#ea55141f', width: 'fit-content', borderRadius: '3px'}}>
                                  {categories.find(c => c.value === item.category)?.label}
                              </Typography>
                              </div>
                              <div style={{width: '70%'}}>
                              <Typography sx={{color: '#000'}}>{item.title}</Typography>
                              </div>
                              <div style={{width: '10%'}}>
                                  <style>
                                    {`
                                      .custom-icon-button {
                                        padding: 13px 15px;
                                        border: 1px solid #F8B62D;
                                        border-radius: 50%;
                                        margin-top: 10px;
                                        background: none;
                                        cursor: pointer;
                                        transition: background-color 0.3s ease;
                                      }
        
                                      .custom-icon-button:hover {
                                        background-color: #F8B62D !important;
                                      }
        
                                      .custom-icon-button:hover svg path {
                                        fill: white;
                                      }
                                    `}
                                  </style>
                                  <button 
                                  className="custom-icon-button"
                                  onClick={() => navigate(item.link)}
                                  style={{padding: '13px 15px', border: '1px solid #F8B62D', borderRadius: '50%', marginTop: '10px', background: 'none', cursor: 'pointer',
                
                                  }}>
                                      <svg width="20" height="20" viewBox="0 0 16 16" fill="#F8B62D" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.75013 8.62513L12.7414 8.62513L9.43326 11.9333C9.37356 11.9909 9.32595 12.0599 9.29319 12.1361C9.26044 12.2124 9.2432 12.2944 9.24248 12.3774C9.24176 12.4604 9.25757 12.5427 9.28899 12.6195C9.32042 12.6963 9.36683 12.7661 9.42551 12.8248C9.48419 12.8834 9.55398 12.9298 9.63079 12.9613C9.7076 12.9927 9.7899 13.0085 9.87288 13.0078C9.95587 13.0071 10.0379 12.9898 10.1141 12.9571C10.1904 12.9243 10.2594 12.8767 10.317 12.817L14.692 8.44201C14.8092 8.3248 14.875 8.16586 14.875 8.00013C14.875 7.8344 14.8092 7.67546 14.692 7.55826L10.317 3.18326C10.1991 3.06941 10.0413 3.00641 9.87738 3.00784C9.71351 3.00926 9.55675 3.07499 9.44087 3.19087C9.32499 3.30675 9.25926 3.46351 9.25784 3.62738C9.25641 3.79125 9.31941 3.94913 9.43326 4.06701L12.7414 7.37513L1.75013 7.37513C1.58437 7.37513 1.4254 7.44098 1.30819 7.55819C1.19098 7.6754 1.12513 7.83437 1.12513 8.00013C1.12513 8.16589 1.19098 8.32486 1.30819 8.44207C1.4254 8.55928 1.58437 8.62513 1.75013 8.62513Z" fill="#F8B62D"/>
                                      </svg>
                                  </button>
                              </div>
                          </div>
                      ))}
                  </div>
          </Box>
        </Stack>
      </Container>
    
    </>
  );
};

export default NewsList;
